import React from 'react';
import { Container, Group, ButtonGroup, GenericSkeleton } from '@landr/maestro';
import MetasBadge from 'components/MetasBadge/MetasBadge';

const PreviewDetailsSkeleton = ({
    showDownloadIconButton,
}: {
    showDownloadIconButton: boolean;
}) => (
    <Group.Item>
        <Container size="xs" aria-busy="true">
            <Group direction="vertical" gutter="sm">
                <Group.Item>
                    <GenericSkeleton width="225px" height="36px" />
                </Group.Item>
                <Group.Item>
                    <GenericSkeleton width="80%" height="16px" />
                </Group.Item>
                <Group.Item>
                    <MetasBadge isLoading={true} gutter="xs" />
                </Group.Item>
                <Group.Item>
                    <>
                        <GenericSkeleton
                            width="320px"
                            height="16px"
                            mt={2}
                            mb={9}
                        />
                        <GenericSkeleton width="90%" height="16px" mb={20} />
                    </>
                </Group.Item>
                <Group.Item>
                    <ButtonGroup>
                        {showDownloadIconButton ? (
                            <GenericSkeleton
                                width="48px"
                                height="48px"
                                mb={4}
                                variant="round"
                            />
                        ) : (
                            <GenericSkeleton
                                width="136px"
                                height="48px"
                                mb={4}
                                variant="round"
                            />
                        )}

                        <GenericSkeleton
                            width="136px"
                            height="48px"
                            mb={4}
                            variant="round"
                        />
                    </ButtonGroup>
                </Group.Item>
            </Group>
        </Container>
    </Group.Item>
);

export default PreviewDetailsSkeleton;
